module.exports = __webpack_public_path__ + "img/home_dark.665d5dbc.png";